import { Action, Reducer, State } from '../use_candidate_profile';
import omit from 'lodash/omit';

export const offersReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setCandidateOffers':
      return {
        ...state,
        candidateOffers: {
          ...state.candidateOffers,
          ...action.payload.candidateOffers,
        },
      };
    case 'setOffer':
      return {
        ...state,
        candidateOffers: {
          ...state.candidateOffers,
          offers: {
            ...state.candidateOffers.offers,
            [action.payload.offer.id]: action.payload.offer,
          },
        },
      };
    case 'setApprovalNotes':
      return {
        ...state,
        candidateOffers: {
          ...state.candidateOffers,
          approvalNotes: action.payload.approvalNotes,
        },
      };
    case 'setSingleOfferLoading':
      // When an offer is loading, remove it from the State's offer hash completely
      return {
        ...state,
        candidateOffers: {
          ...state.candidateOffers,
          offers: omit(state.candidateOffers.offers, action.payload.id),
        },
      };
    case 'setHasOutstandingOffers':
      return {
        ...state,
        header: {
          ...state.header,
          hasOutstandingOffers: action.payload,
        },
      };
    case 'setShowOutdatedApprovalWarning':
      return {
        ...state,
        candidateOffers: {
          ...state.candidateOffers,
          showOutdatedApprovalWarning: action.payload,
        },
      };
    case 'setExpandedOffer':
      return {
        ...state,
        expandedOffer: action.payload,
      };
    case 'getOfferDetails': {
      const {
        payload: { offer },
      } = action;
      return {
        ...state,
        offer,
      };
    }
    default:
      return state;
  }
};
